import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-6 bg-gray-50" data-id="element-78">
      <div className="max-w-3xl mx-auto text-center" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-80">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-gray-900 mb-10" data-id="element-81">
            Antes de ver propiedades, habla con nosotros
          </h2>

          <div className="flex justify-center" data-id="element-82">
            <button className="w-full sm:w-auto flex items-center justify-center gap-2 bg-brand-600 hover:bg-brand-700 text-white px-8 py-3.5 rounded-full font-medium transition-all text-base" data-id="element-83">
              Agenda tu llamada
              <ArrowRight size={18} data-id="element-84" />
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}